import { useParams, useSearchParams } from "react-router";
import { usePageTitle } from "@shared/client/view";
import { Button } from "@shared/components/ui/button";
import { useLocale, useT } from "@shared/client/locale";
import { LEGAL_ENTITY, legalUrl } from "@shared/lib/legal";

/**
 * Couper le récapitulatif hebdomadaire depuis le lien d'un e-mail produit :
 * un bouton, sans connexion. Ouvrir la page ne change rien (un antivirus qui
 * visite les liens ne désinscrit personne) : c'est le bouton qui envoie le
 * POST. La page ne lit pas la base et ne dit jamais si le jeton existe.
 */
export default function EmailPreferencesPage() {
  const t = useT();
  const locale = useLocale();
  const copy = t.auth.emailPreferences;
  usePageTitle(t.auth.pageTitles.emailPreferences);
  const { token = "" } = useParams();
  const [params] = useSearchParams();
  const done = Boolean(params.get("done"));

  return (
    <main className="min-h-screen bg-background">
      <section className="mx-auto w-full max-w-[560px] px-5 py-16">
        <h1 className="m-0 font-serif text-[clamp(28px,4vw,36px)] leading-[1.1] font-normal tracking-[-0.02em]">
          {done ? copy.done : copy.title}
        </h1>
        {done ? (
          <p className="mt-4 text-[15px] leading-relaxed text-muted-foreground">{copy.doneBody}</p>
        ) : (
          <>
            <p className="mt-4 text-[15px] leading-relaxed text-muted-foreground">{copy.body}</p>
            {/* Formulaire natif : l'API répond par une redirection vers ?done=1. */}
            <form
              action={`/api/public/emails/unsubscribe/${encodeURIComponent(token)}`}
              className="mt-7"
              method="post"
            >
              <input name="confirm" type="hidden" value="1" />
              <Button size="lg" type="submit">
                {copy.submit}
              </Button>
            </form>
          </>
        )}
        <p className="mt-10 text-[13px] leading-relaxed text-muted-foreground">
          <a className="text-primary hover:underline" href="/app/settings#notifications">
            {copy.manage}
          </a>{" "}
          ·{" "}
          <a className="text-primary hover:underline" href={`mailto:${LEGAL_ENTITY.email}`}>
            {LEGAL_ENTITY.email}
          </a>{" "}
          ·{" "}
          <a className="text-primary hover:underline" href={legalUrl("privacy", locale)}>
            {copy.privacy}
          </a>
        </p>
      </section>
    </main>
  );
}
